import './App.css';

function App() {
  const handleSubmit = (e) => {
    e.preventDefault();
    const message = e.target.elements.message.value;
    console.log("Message from visitor:", message);
    alert("Thanks! We'll get in touch soon.");
    e.target.reset();
  };

  return (
    <div className="coming-soon-container">
      <div className="overlay">
        <img src="/ua-logo.png" alt="Universal Ally Logo" className="logo" />
        <h1>🚀 Universal Ally</h1>
        <p>We’re building something amazing. Launching soon.</p>
        <form onSubmit={handleSubmit}>
          <textarea
            name="message"
            placeholder="Leave us a message..."
            required
          />
          <button type="submit">Send</button>
        </form>
      </div>
    </div>
  );
}

export default App;

<form action="https://formspree.io/f/movwqepv" method="POST">
  <textarea
    name="message"
    placeholder="Leave us a message..."
    required
  ></textarea>
  <button type="submit">Send</button>
</form>
